import React from 'react';
import styles from 'components/tag/tag.module.scss';
import classNames from 'classnames';

export const TagsList = ({ children, expanded }) => {
  return <div className={classNames('tags', styles.tagsWrapper, { expanded })}>{children}</div>;
};
